import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { useGetSupportMessageForCurrentTenantSupportMessageGet } from "@/api-v3";
import { CardContainer } from "@/components/card-container";
import { ErrorBox } from "@/components/error-box";
import { useParticipantCountry } from "@/features/auth";
import { ContactsListComponent } from "@/features/support/components/contacts-list";
import { useSupportContacts } from "@/features/support/hooks/use-support-contacts";

export const SupportPage = () => {
  const { t } = useTranslation();
  const { countryCode } = useParticipantCountry();
  const { data: supportMessage } =
    useGetSupportMessageForCurrentTenantSupportMessageGet();

  const { contacts, hasContacts, isLoading, isFetched } = useSupportContacts();

  if (isFetched && !hasContacts) {
    return <Navigate to="/home" replace />;
  }

  const messageHtml = supportMessage?.message_html;

  return (
    <CardContainer>
      <CardContainer.Header>
        <CardContainer.HeaderContent>
          <CardContainer.CardTitle>
            {t("tabBar_support")}
          </CardContainer.CardTitle>
        </CardContainer.HeaderContent>
      </CardContainer.Header>
      <CardContainer.Content>
        <ErrorBox
          data-test-id="support-alert"
          text={t("helpAndSupport_emergencyWarningDescription")}
        />

        <div className="my-8">
          <h1 className="text-xl font-semibold leading-relaxed mb-1.5">
            {t("helpAndSupport_howCanWeHelp")}
          </h1>
          {messageHtml ? (
            <div
              className="leading-relaxed mb-4"
              dangerouslySetInnerHTML={{ __html: messageHtml }}
            />
          ) : (
            <div className="leading-relaxed mb-4">
              {t("support_description")}
            </div>
          )}
          <ContactsListComponent
            contacts={contacts}
            isLoading={isLoading}
            userCountry={countryCode ?? undefined}
            dataTestId="support"
          />
        </div>
      </CardContainer.Content>
    </CardContainer>
  );
};
